import {
  type SansanConnectionResponse,
  type SansanConnectionStatus,
} from "@/features/sansanIntegration/types";

/**
 * Sansan連携の状態を画面表示用の3状態に変換する。
 * 未取得（`undefined`）・未連携（`null`）は`NOT_CONNECTED`、連携中でキーが失効していれば`INVALID`とする。
 */
export const deriveConnectionStatus = (
  connection: SansanConnectionResponse | null | undefined
): SansanConnectionStatus => {
  if (connection == null) {
    return "NOT_CONNECTED";
  }
  return connection.isApiKeyValid ? "VALID" : "INVALID";
};
